/* eslint-disable class-methods-use-this */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import cx from 'classnames';
import { pickProps, omitProps } from 'utils/react';
import SelectableItem from '../SelectableItem';
import { itemPropTypes } from '../propTypes';
import styles from './SelectContainer.module.scss';

export default class MultiSelectableItem extends Component {
    static displayName = 'MultiSelectableItem';

    static propTypes = {
        item: PropTypes.shape(itemPropTypes).isRequired,
        index: PropTypes.number.isRequired,
        innerRef: PropTypes.ref(),
        selected: PropTypes.bool,
        highlight: PropTypes.bool,
        tabIndex: PropTypes.number,
        onClick: PropTypes.func,
        renderDecorator: PropTypes.func,
        checkboxClassName: PropTypes.string,
        className: PropTypes.string,
        children: PropTypes.node,
    };

    static defaultProps = {
        innerRef: null,
        selected: false,
        highlight: false,
        tabIndex: -1,
        onClick: noop,
        renderDecorator: noop,
        checkboxClassName: null,
        className: null,
        children: null,
    };

    handleBeforeChange = () => false;

    handleClick = (event) => {
        const { item, index, onClick } = this.props;
        onClick(event, item, index);
    };

    render() {
        const {
            item,
            selected,
            highlight,
            renderDecorator,
            className,
            checkboxClassName,
            innerRef,
            tabIndex,
            children,
        } = this.props;

        const { value, disabled, ...itemProps } = item;

        const dropdownItemClassNames = cx('dropdown-item', {
            disabled,
            selected,
            highlight,
        });

        const selectableProps = pickProps(this.props, SelectableItem);
        const otherProps = omitProps(this.props, MultiSelectableItem);

        return (
            <li role="none" className={styles.menuItem}>
                <SelectableItem
                    {...itemProps}
                    {...otherProps}
                    {...selectableProps}
                    value={value}
                    component="button"
                    type="button"
                    role="option"
                    innerRef={innerRef}
                    tabIndex={tabIndex}
                    disabled={disabled}
                    renderDecorator={renderDecorator}
                    className={cx(dropdownItemClassNames, className)}
                    inputClassName={checkboxClassName}
                    aria-disabled={disabled}
                    aria-selected={selected}
                    onClick={this.handleClick}
                    onBeforeChange={this.handleBeforeChange}
                >
                    {children}
                </SelectableItem>
            </li>
        );
    }
}
